import { render } from "./smsSettingsNew.vue?vue&type=template&id=04d3d70a&scoped=true"
import script from "./smsSettingsNew.vue?vue&type=script&lang=js"
export * from "./smsSettingsNew.vue?vue&type=script&lang=js"

import "./smsSettingsNew.vue?vue&type=style&index=0&id=04d3d70a&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d3d70a"]])

export default __exports__